import { Component, ViewEncapsulation, output, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ApContentPipe } from '@ap/content';
import { ApPopoverComponent } from '@ap/popover';
import '@asn/badge';
import '@asn/icon';

import { ProfileMenu, ProfileMenuItem } from '../../header.model';
import { ApProfileMenuComponent } from '../../profile-menu/profile-menu.component';

@Component({
    selector: 'ap-horizontal-menu-user',
    templateUrl: './horizontal-menu-user.component.html',
    styleUrls: ['./horizontal-menu-user.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApProfileMenuComponent, ApContentPipe, ApPopoverComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApHorizontalMenuUserComponent {
    /**
     * Is user logged in?
     * If not set no login will be shown.
     * If false login-button will be shown.
     * If true logged in state will be shown
     */
    public readonly isLoggedIn = input<boolean>();

    /**
     * Profile menu with user data
     */
    public readonly profileMenu = input<ProfileMenu>();

    /**
     * Emits event to login
     * Passes `isLoggedIn` boolean
     */
    public readonly loginLogout = output<boolean>();

    /**
     * Eventemitter that is emitted on click, keyboard enter and keyboard space
     * Emits clicked profile menu item
     */
    public readonly itemClicked = output<ProfileMenuItem>();
}
